import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f5170e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "placeholder"
}

import { computed, PropType, provide } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { Slide } from '@/types/slides'
import { injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'

import ThumbnailElement from './ThumbnailElement.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  slide: {
    type: Object as PropType<Slide>,
    required: true,
  },
  size: {
    type: Number,
    required: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const { viewportRatio } = storeToRefs(useSlidesStore())

const background = computed(() => props.slide.background)
const { backgroundStyle } = useSlideBackgroundStyle(background)

const scale = computed(() => props.size / VIEWPORT_SIZE)
provide(injectKeySlideScale, scale)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "thumbnail-slide",
    style: _normalizeStyle({
      width: __props.size + 'px',
      height: __props.size * _unref(viewportRatio) + 'px',
    })
  }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "elements",
          style: _normalizeStyle({
        width: _unref(VIEWPORT_SIZE) + 'px',
        height: _unref(VIEWPORT_SIZE) * _unref(viewportRatio) + 'px',
        transform: `scale(${_unref(scale)})`,
      })
        }, [
          _createElementVNode("div", {
            class: "background",
            style: _normalizeStyle(_unref(backgroundStyle))
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slide.elements, (element, index) => {
            return (_openBlock(), _createBlock(ThumbnailElement, {
              key: element.id,
              elementInfo: element,
              elementIndex: index + 1
            }, null, 8, ["elementInfo", "elementIndex"]))
          }), 128))
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, "加载中 ..."))
  ], 4))
}
}

})